// Sponsor images

import securitySm from "../assets/sponsors/security-small.webp";
import securityMd from "../assets/sponsors/security-medium.webp";

import usbankSm from "../assets/sponsors/usbank-small.webp";
import usbankMd from "../assets/sponsors/usbank-medium.webp";

import zynexSm from "../assets/sponsors/zynex-small.webp";
import zynexMd from "../assets/sponsors/zynex-medium.webp";

import maddiosSm from "../assets/sponsors/maddios-small.webp";
import maddiosMd from "../assets/sponsors/maddios-medium.webp";

import kenSm from "../assets/sponsors/ken-small.webp";
import kenMd from "../assets/sponsors/ken-medium.webp";

import casaSm from "../assets/sponsors/casa-small.webp";
import casaMd from "../assets/sponsors/casa-medium.webp";

export const sponsorData = [
  { imageUrl: { small: casaSm, medium: casaMd }, companyName: "Casa Gutierrez Mexican Food" },
  { imageUrl: { small: kenSm, medium: kenMd }, companyName: "Ken's Auto service" },
  { imageUrl: { small: maddiosSm, medium: maddiosMd }, companyName: "Uncle Maddio's pizza" },
  { imageUrl: { small: securitySm, medium: securityMd }, companyName: "Security Service Federal Credit Union" },
  { imageUrl: { small: usbankSm, medium: usbankMd }, companyName: "Us Bank" },
  { imageUrl: { small: zynexSm, medium: zynexMd }, companyName: "Zynex medical" },
];
